"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EINVOICE_ENABLED = exports.DEFAULT_RATE_FOR_CATEGORY = exports.STANDARD_VAT_RATE = exports.DEFAULT_UNIT = exports.DEFAULT_COUNTRY = exports.DEFAULT_CURRENCY = exports.PROFILE_ID = exports.SPEC_ID = exports.KIT_VERSION = void 0;
exports.KIT_VERSION = '0.1.0';
/**
 * Placeholder specification / profile identifiers.
 *
 * SARS has NOT yet published its Core Invoice Usage Specification (CIUS) — that
 * lands in Phase 2 (Solution Development, 2027/28). When it does, only these two
 * constants and the serialisers in accessPoint.ts change.
 */
exports.SPEC_ID = 'urn:hailio:einvoice:za:draft-0.1';
exports.PROFILE_ID = 'urn:hailio:profile:za:dctce-5corner';
exports.DEFAULT_CURRENCY = 'ZAR';
exports.DEFAULT_COUNTRY = 'ZA';
/** UN/ECE Rec 20 code for "one / each". */
exports.DEFAULT_UNIT = 'C62';
/** SA standard VAT rate (%). Kept as a constant so a rate change is one edit. */
exports.STANDARD_VAT_RATE = 15;
exports.DEFAULT_RATE_FOR_CATEGORY = {
    S: exports.STANDARD_VAT_RATE,
    Z: 0,
    E: 0,
    O: 0,
};
/**
 * MASTER FEATURE FLAG.
 *
 * Keep FALSE until (a) SARS finalises the e-invoice syntax and (b) the accredited
 * access-point network is live. While false, apps still BUILD, validate and store
 * structured e-invoices internally — that is what makes each app legitimately
 * "VAT-Modernisation ready" — but nothing is transmitted to any network.
 *
 * Apps may also gate their own UI on this via `isEInvoiceEnabled()`.
 */
exports.EINVOICE_ENABLED = false;
